// extracted by mini-css-extract-plugin
export default {"svgContainer":"index_svgContainer__cC5SJ","title":"index_title__fCKus","controls":"index_controls__QlZhe","svgWrap":"index_svgWrap__rb3lw"};